import { DateTimeFormatStyle } from "@hopper-i18n/formatter";

/**
 * Custom date formats used across the application.
 */
export const CustomDateTimeFormatStyles = {
  /**
   * en-US: Jul 17, 2025, 10:37 AM
   *
   * en-GB: 17 Jul 2025, 10:37
   *
   * es-MX: 17 jul 2025, 10:37 a.m.
   */
  ShortMonthYearDateTime: DateTimeFormatStyle.Custom({
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }),

  /**
   * en-US: Jul 17
   *
   * en-GB: 17 Jul
   *
   * es-MX: 17 jul
   */
  ShortMonthDayDate: DateTimeFormatStyle.Custom({
    month: "short",
    day: "numeric",
  }),
};
